<a
  id="{{item.artifact_id}}"
  class="thumbnail-list-item"
  queryParamsHandling="merge"
  [queryParams]="item.$$refData?.queryParams"
  [routerLink]="getRouterLink(item)"
  [ngClass]="{'thumbnail-list-item--selected' : searchContainer.selections.selected[item.artifact_id]}"
>
  <div class="thumbnail-list-item__indicators">
    <div
      class="thumbnail-list-item__checkbox-container"
      [ngClass]="{'thumbnail-list-item__checkbox-container--selected' : searchContainer.selections.selected[item.artifact_id]}"
    >
      <span
        class="checkbox-tooltip-wrapper"
        [class.cursor-not-allowed]="isCheckboxDisabled(item) && !item.$$used"
        [matTooltip]="isCheckboxDisabled(item) && !item.$$used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
        (click)="$event.stopPropagation()"
        (keydown)="null"
      >
        <mat-checkbox
          (click)="select(item, $event)"
          (keydown)="null"
          [checked]="isCheckboxSelected(item)"
          [disabled]="isCheckboxDisabled(item)"
        />
      </span>
    </div>

    @if (item?.is_restricted) {
      <app-restricted-indicator/>
    }
  </div>

  <app-search-result-thumbnail-image
    class="thumbnail-list-item__thumb"
    [item]="item"
  />

  <div class="thumbnail-list-item__icon-container">
    <mat-icon>
      {{ getSymbolFromObjectType(item.object_type) }}
    </mat-icon>
  </div>

  <div class="thumbnail-list-item__content-area">
    <span class="thumbnail-list-item__title">
      <span class="thumbnail-list-item__title-text">
        {{ item.artifact_name }}
      </span>
      @if (item.object_type === 'folder' && item['$$folderItemCount'] !== undefined && item['$$folderItemCount'] !== null) {
        <span class="thumbnail-list-item__folder-items">
          {{ item['$$folderItemCount'] }}
          <span class="thumbnail-list-item__folder-items-label">
            {{ 'TRANS__FIELD__OBJECTS' | translate }}
          </span>
        </span>
      }
    </span>

    <div class="thumbnail-list-item__content">
      @for (field of getDisplayFields(item); track $index) {
        <div class="thumbnail-list-item__field">
          <div class="thumbnail-list-item__field-title">
            {{ field.title }}
          </div>
          <div class="thumbnail-list-item__field-value">
            <app-overview-field
              [overviewField]="field"
              [viewName]="searchContainer.searchResultViewName"
              [toneDownTextColor]="true"
            ></app-overview-field>
          </div>
        </div>
      }
    </div>
  </div>

  @if (item.package_placement && objectPageV2) {
    <app-search-result-package-indicator
      class="thumbnail-list-item__package-badge"
      [item]="item"
      [packageDataIsObject]="true"
    />
  }
</a>
